import { render, staticRenderFns } from "./StatisticsHeader.vue?vue&type=template&id=1007396d"
import script from "./StatisticsHeader.vue?vue&type=script&lang=ts"
export * from "./StatisticsHeader.vue?vue&type=script&lang=ts"
import style0 from "./StatisticsHeader.vue?vue&type=style&index=0&id=1007396d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports